import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { academylist } from "../../../services/admin";
import { createvisitor, detailvisitor } from "../../../services/common";
import { toast } from "react-toastify";
import Select from "react-select";

export default function Addvisitors() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [vname, setVName] = useState("");
  const [vdate, setVDate] = useState("");
  const [vcat, setVCat] = useState("");
  const [vmeet, setVMeet] = useState("");
  const [omeet, setOMeet] = useState("");
  const [vphone, setVPhone] = useState("");
  const [intime, setIntime] = useState("");
  const [outtime, setOuttime] = useState("");

  const [errmsg, setErrmsg] = useState("");
  const [visitsub, setVisitsub] = useState(false);

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");

  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });

    if (path === "visitordetail") {
      detailvisitor(id).then((res) => {
        if (res.status === true) {
          setVName(res.data.visitor_name);
          setVPhone(res.data.phone);
          setVMeet(res.data.meeting_with);
          setOMeet(res.data.other_visitor);
          setVCat(res.data.visitor_type);
          setIntime(res.data.visitor_intime);
          setOuttime(res.data.visitor_outtime);
          setVDate(moment(res.data.visitor_date).format("YYYY-MM-DD"));
          academylist().then((res1) => {
            if (res1.status === true) {
              let arr = [];
              if (res1.data.details.length > 0) {
                for (let i = 0; i < res1.data.details.length; i++) {
                  if (res1.data.details[i].id == res.data.academy_id) {
                    arr.push({
                      value: res1.data.details[i].id,
                      label:
                        res1.data.details[i].name +
                        " - " +
                        res1.data.details[i].code,
                    });
                  }
                }
                setAcaID(arr[0]);
              }
            }
          });
        }
      });
    } else {
      if (localStorage.getItem("ADate") !== '') {
            setVDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
          } else {
            setVDate(moment(new Date()).format("YYYY-MM-DD"));
          }

          if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
              if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                  for (let i = 0; i < res.data.details.length; i++) {
                    if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                      arr.push({
                        value: res.data.details[i].id,
                        label:
                          res.data.details[i].name + " - " + res.data.details[i].code,
                      });
                    }
                    if (arr.length > 0) {
                      setAcaID(arr[0]);
                      
                    }
                  }
                 
                }
              }
            });
          }
     
    }
  }, [location.pathname]);
  function handlePhone(e) {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVPhone(e.target.value);
    }
  }

  function submitvisit(e) {
    e.preventDefault();
    setVisitsub(true);
    let chk = "";

    if (
      vname !== "" &&
      vdate !== "" &&
      vcat !== "" &&
      vmeet !== "" &&
      vphone !== "" &&
      intime !== "" 
      // &&
      // outtime !== ""
    ) {
      if (vcat === "Other" && omeet === "") {
        chk = "Other";
      }
      if (chk === "") {
        setLoading(true);
        const temp = new FormData();
        temp.append("visitor_name", vname);
        temp.append("phone", vphone);
        temp.append("visitor_type", vcat);
        if (vcat !== "Other") {
          temp.append("other_visitor", omeet);
        } else {
          temp.append("other_visitor", "");
        }
        temp.append("meeting_with", vmeet);
        temp.append("visitor_intime", intime);
        temp.append("visitor_outtime", outtime);
        temp.append("visitor_date", vdate);
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        if (urllink === "visitordetail") {
          temp.append("id", id);
        }
        createvisitor(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            setVisitsub(false);
            toast.success(res.message);
            navigate("/frontdesk/allvisitors");
          } else {
            setLoading(false);
            setVisitsub(false);
            toast.error(res.message);
          }
        });
      }
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">
          {urllink === "addvisitors" ? "Add Visitors" : "Visitor Details"}
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Front Desk</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "addvisitors" ? "Add Visitors" : "Visitor Details"}
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-lg-12">
                        <div className="row">
                          {localStorage.getItem("Role") === "1" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Select Academy{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <Select
                                  className="default-select"
                                  placeholder="Select Academy"
                                  value={acaid}
                                  options={aclist}
                                  onChange={handleAcademy}
                                  isSearchable={true}
                                  isClearable
                                  hidden
                                />
                                {visitsub && acaid === "" && (
                                  <span className="text-danger">
                                    Please Select Academy
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Name<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Visitor Name"
                                onChange={(e) => setVName(e.target.value)}
                                value={vname}
                              />
                              {visitsub && vname === "" && (
                                <span className="text-danger">
                                  Please Enter Visitor Name
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Date<span className="text-danger"> *</span>
                              </label>
                              <input
                                className="form-control"
                                type="date"
                                onChange={(e) => setVDate(e.target.value)}
                                value={vdate}
                              />
                              {visitsub && vdate === "" && (
                                <span className="text-danger">
                                  Please Select Date
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Visitor Category Type
                              </label>
                              <select
                                className="default-select form-control wide"
                                onChange={(e) => setVCat(e.target.value)}
                                value={vcat}
                              >
                                <option value="" disabled>
                                  Select Visitor Category Type
                                </option>
                                <option value="Parents">Parents</option>
                                <option value="Student Relatives">
                                  Student Relatives
                                </option>
                                <option value="Teachers Parents">
                                  Teachers Parents
                                </option>
                                <option value="Other">Other</option>
                              </select>
                              {visitsub && vcat === "" && (
                                <span className="text-danger">
                                  Please Select Visitor Category
                                </span>
                              )}
                            </div>
                          </div>
                          {vcat === "Other" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Other Visitor Category
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Visitor Category"
                                  onChange={(e) => setOMeet(e.target.value)}
                                  value={omeet}
                                />
                                {visitsub && omeet === "" && (
                                  <span className="text-danger">
                                    Please Enter Other Visitor Category
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Meeting With
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Meeting With"
                                onChange={(e) => setVMeet(e.target.value)}
                                value={vmeet}
                              />
                              {visitsub && vmeet === "" && (
                                <span className="text-danger">
                                  Please Enter Meeting With
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Phone Number
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Phone Number"
                                onChange={handlePhone}
                                value={vphone}
                                maxLength={10}
                              />
                              {visitsub && vphone === "" && (
                                <span className="text-danger">
                                  Please Enter Phone Number
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                In Time<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="time"
                                className="form-control"
                                onChange={(e) => setIntime(e.target.value)}
                                value={intime}
                              />
                              {visitsub && intime === "" && (
                                <span className="text-danger">
                                  Please Enter In Time
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Out Time
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="time"
                                className="form-control"
                                onChange={(e) => setOuttime(e.target.value)}
                                value={outtime}
                              />
                              {/* {visitsub && outtime === "" && (
                                <span className="text-danger">
                                  Please Enter Out Time
                                </span>
                              )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="res-right mt-4 mb-4 me-4">
              <button className="btn btn-success me-2" onClick={submitvisit}>
                Submit
              </button>
              {urllink !== "addvisitors" && (
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate("/frontdesk/allvisitors")}
                >
                  Back
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
